import { t } from "@/i18n-js/instance";
import { PaywallCurrencyAmountFormInput } from "@circle-react/components/Paywalls/PaywallCurrencyAmountFormInput";
import type { CommunityMemberCharge } from "@circle-react/types/CommunityMemberCharge";
import { Form } from "@circle-react-uikit/Form";
import { formId, localeStringRoot } from "./constants";
import { useRefundChargeForm } from "./hooks/useRefundChargeForm";

interface RefundChargeFormProps {
  charge: CommunityMemberCharge;
}

export const RefundChargeForm = ({ charge }: RefundChargeFormProps) => {
  const { transformValueIntoCurrency, minAmountToRefund, maxAmountToRefund } =
    useRefundChargeForm({ charge });

  const currency = charge.currency;

  return (
    <div className="flex flex-col space-y-2 pt-2">
      <Form.Item
        className="border-0"
        labelClassName="text-sm font-semibold"
        name="amount"
        translationRoot={`${localeStringRoot}.refund_form`}
        hidePlaceholder
        hideDescription
        hiddenField
        id={formId}
        transformValue={transformValueIntoCurrency}
        rules={{
          required: true,
          validate: {
            minAmountToRefund,
            maxAmountToRefund,
          },
        }}
      >
        <PaywallCurrencyAmountFormInput currency={currency} />
      </Form.Item>
      <Form.Item
        className="border-0"
        labelClassName="text-sm font-semibold"
        name="reason_details"
        translationRoot={`${localeStringRoot}.refund_form`}
        hideDescription
        hiddenField
        id={formId}
        rules={{
          required: t(
            `${localeStringRoot}.refund_form.alerts.reason_details_required`,
          ),
          maxLength: {
            value: 255,
            message: t(
              `${localeStringRoot}.refund_form.alerts.reason_details_max_length`,
            ),
          },
        }}
      >
        <Form.Input name="reason_details" variant="textarea" />
      </Form.Item>
    </div>
  );
};
